// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"2d0a5472","21":"01d9a006","149":"175fe1c8","298":"e79f1f04","400":"fc073e08","584":"a4fe211c"}[chunkId] + ".chunk.css";
};